/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
export class RegexValidationStrings {
	public static NUMERIC = '^[0-9.]+$';
	public static INTEGER = '^-?[0-9]+$';
	public static DECIMAL = '^([0-9]+(\\.)?([0-9]+)?)$';
	public static HALF = '^([0-9]d*)+(?:.[05]{1})?$';
	// added extra backslash before . to 'escape' decimal point as
	// any character was being accepted
	public static DECIMAL_ONE = '^-?[0-9]+(\\.[0-9]{1})?$';
	public static DECIMAL_TWO = '^-?[0-9]+(\\.[0-9]{1,2})?$';
	//public static DECIMAL_THREE = '^-?[0-9]+(\\.[0-9]{1,3})?$';
	public static DECIMAL_THREE = '^-?[0-9]{0,11}(?:\.[0-9]{1,3})?$';
	public static ESTIMATE_VALUE = '^-?[0-9]{0,3}(?:\.(0|00|000|125|25|250|375|5|50|500|625|75|750|875))?$';
	public static DECIMAL_FOUR = '^-?[0-9]+(\\.[0-9]{1,4})?$';
	public static ALPHA = '^[a-zA-Z ]+$';
	public static ALPHANUMERIC = '^[a-zA-Z0-9- ]+$';
	public static COMMA_FORMATTED_INTEGER = '^-?(\\d{1,3}(,\\d{3})*|(\\d+))$';
	public static COMMA_FORMATTED_DECIMAL_TWO = '^-?(\\d{1,3}(,\\d{3})*|(\\d+))(\\.\\d{1,2})?(?<!\\.)$';
	public static COMMA_FORMATTED_DECIMAL_SEVEN = '^-?(\\d{1,3}(,\\d{3})*|(\\d+))(\\.\\d{1,7})?(?<!\\.)$';
	public static EMAIL = '^\\s*([a-z\\.A-Z0-9._\\-]+[@][a-zA-Z0-9_\\-]{1,}\\.[a-zA-Z\\.0-9_\\-]{2,})\\s*$';
	public static POSTCODE = '^\\s*([A-Za-z]{1,2}[0-9]{1,2}[A-Za-z]{0,1})\\s*([0-9][A-Za-z]{2})\\s*';
	public static MAPS_LOCATION = '^-?\\d+\\.?\\d*,\\s*-?\\d+\.?\\d*$';
	public static PHONE_NUMBER = '^\\s*((\\(?[0][0-9]{2,5}\\)?)|(\\s*[0][0-9 ]{2,5}\\s*))[0-9 ]{4,10}\\s*$';
	public static PERSON_NAME = "^[a-zA-Z-' ]+$";
	public static COMPANY_NAME = "^[A-Za-z0-9()./&,' -]*$";
	public static PASSWORD = '^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&`¬\\(\\)\\[\\]\\{\\}])[A-Za-z\\d@$!%*#?&`¬\\(\\)\[\\]\\{\\}]*$';
	public static WEBSITE_URL = "^((https?|ftp):\\/\\/)?[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)+(\\/[A-Za-z0-9-\\.\\/?&;~=\\$_\\+\\*\\(\\)'#]*)*$";
	public static NI_NUMBER = '^[a-ceghj-pr-tw-zA-CEGHJ-PR-TW-Z]{1}[a-ceghj-pr-tw-zA-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[a-dfmA-DFM]{0,1}$';
	public static TIME_VALUES = '^(?:[01][0-9]|2[0-3]):[0-5][0-9]$';
	public static INTEGER_EIGHT = '^[0-9]{8}$';
	public static SORT_CODE = '^[0-9]{2}-[0-9]{2}-[0-9]{2}$';
}
